<template>
  <div class="content">
    <el-page-header @back="goBack" class="pageHeader" :content="`院系${$store.state.themeTitle}室详情`">
    </el-page-header>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="专业">
          <el-select v-model="formInline.major" clearable filterable placeholder="请选择专业">
            <el-option v-for="item in majors" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载{{$store.state.themeTitle}}室导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>-->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="structure_1" label="院系名称" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column>
        <custom-table-column  prop="training_name" :label="`${$store.state.themeTitle}室名称`" width="150">
        </custom-table-column>
        <custom-table-column prop="school_area" label="校区" width="140">
        </custom-table-column>
        <custom-table-column prop="building_name" label="楼宇名称" min-width="140">
        </custom-table-column>
        <custom-table-column prop="room_name" label="房间号" width="160">
        </custom-table-column>
        <custom-table-column prop="address" label="位置" min-width="160">
        </custom-table-column>
        <custom-table-column prop="area" label="面积(m²)" width="120">
        </custom-table-column>
        <custom-table-column prop="state" label="目前状态" width="120">
        </custom-table-column>
        <custom-table-column prop="is_motor_room" label="是否机房" width="120">
        </custom-table-column>
        <custom-table-column prop="main_func" label="主要教学功能" min-width="220">
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  title="title" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      formInline: {
        structure_1: '',
        major: '',
        type: '',
        training_name: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      total1: 0,
      detailDialogVisible: false,
      centerDialogVisible1: false,
      dialogVisible1: false,
      bases: [],
      eqs: [],
      loading: false,
      users: [],
      majors: [],
    };
  },
  created() {
    this.formInline.structure_1 = this.$route.query.structure_name;
    this.getMajor();

  },
  computed: {},
  mounted() {},
  methods: {
    goBack() {
      history.back();
    },
    async getMajor() {
      let res = await this.$api.instance.getMajor({ structure_ids: this.$route.query.structure_ids });
      if (res.code == 0 && res.data) {
        this.majors = res.data;
      }
    },
    async deleteTarinRoom() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.createTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateTarinRoom(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getRooms(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: 282px;
}
</style>
